import { getCurrentInstance, computed, reactive } from 'vue';
import { ModuleBudgetSourceProperty } from '@/stores/moduleConst';
import { useStore } from 'vuex';

// Combo grid Tài khoản nợ, có
export const useCacheBudgetSourcePropertyComboConfig = () => {
  const { proxy } = getCurrentInstance();
  const store = useStore();

  const budgetSourcePropertyData = computed(() => {
    const budgetSourceProperty = store.getters[`${ModuleBudgetSourceProperty}/items`];
    return budgetSourceProperty.filter(x => !x.inactive);
  });
  // config columns combo
  const cacheBudgetSourcePropertyComboConfig = reactive({
    data: budgetSourcePropertyData,
    columns: [
      {
        title: 'Mã nguồn',
        dataField: 'budget_source_property_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nguồn',
        dataField: 'budget_source_property_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_source_property_code',
    valueField: 'budget_source_property_code',
    queryMode: 'local',
    dropdownWidth: 600,
  });

  return { cacheBudgetSourcePropertyComboConfig };
};
